/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable no-plusplus */
import '../style.css';
import drawLine from './tools/drawLine';
import penAction from './tools/pen';
import eraserAction from './tools/eraser';
import strokeAction from './tools/stroke';
import colorswapAction from './tools/colorswap';
import rectangleAction from './tools/rectangle';
import lighterAction from './tools/lighter';
import paintcanvasAction from './tools/paintcanvas';
import rainbowAction from './tools/rainbow';
import colorpickerAction from './tools/colorpicker';

import flipAction from './transform/flip';
import rotateAction from './transform/rotate';

import gifshot from '../node_modules/gifshot';
import APNGencoder from './libs/canvas2apng';


const landingPage = document.getElementById('start');
landingPage.onclick = function () {
  document.getElementById('landingPage').style.display = 'none';
};

// ==================      FRAMES / PREVIEW / BUTTONS      ================== //

const framesHTML = document.getElementById('frames');
const addFrameBtn = document.getElementById('addFrame');
const newFrameBtn = document.getElementById('newFrame');
const fullscreen = document.getElementById('fullscreen');
const canvasMain = document.getElementById('canvasToPaint');
const canvasToCursor = document.getElementById('canvasToCursor');

const speedRange = document.getElementById('speedRange');
const speedRangeValue = document.getElementById('speedRangeValue');
const cursorCoords = document.getElementById('cursorCoords');

const canvasPreview = document.getElementById('canvasPreview');
const ctxPreview = canvasPreview.getContext('2d');

const frameNames = [];
for (let i = 0; i < 100; i += 1) {
  const x = `frame${i}`;
  frameNames.push(x);
  window[`frame${i}`] = document.getElementById(x);
}

const framesUrls = [];

// ==================      TOOLS      ================== //

const tools = document.getElementById('tools');

const toolPaint = document.getElementById('paint');
const toolColorpicker = document.getElementById('colorpicker');
const toolPen = document.getElementById('pen');
const toolRectangle = document.getElementById('rectangle');
const toolColorswap = document.getElementById('colorswap');
const toolPaintcanvas = document.getElementById('paintcanvas');
const toolStroke = document.getElementById('stroke');
const toolEraser = document.getElementById('eraser');
const toolLighter = document.getElementById('lighter');
const toolRainbow = document.getElementById('rainbow');

const primaryColor = document.getElementById('primaryColor');
const secondaryColor = document.getElementById('secondaryColor');
const swapColors = document.getElementById('swapColors');

// ==================      TRANSFORM      ================== //

const tranform = document.getElementById('tranform');
const exportGif = document.getElementById('exportGif');
const exportApng = document.getElementById('exportApng');
const apngToGDrive = document.getElementById('apngToGDrive');
const apngToGDriveWait = document.getElementById('apngToGDriveWait');


const canvasSize = document.getElementById('size');

// ==================      exportGif FUNCTIONALITY      ================== //

function prepareForGif() {
  const frameImages = [];
  for (let i = 0; i < framesUrls.length; i++) {
    const canvasGif = document.createElement('canvas');
    canvasGif.width = canvasCurrVirtualSize;
    canvasGif.height = canvasCurrVirtualSize;
    const ctxGif = canvasGif.getContext('2d');
    ctxGif.fillStyle = 'black';
    ctxGif.fillRect(0, 0, canvasCurrVirtualSize, canvasCurrVirtualSize);
    const frameSrc = framesUrls[i];
    const frame = new Image();
    frame.src = frameSrc;
    ctxGif.drawImage(frame, 0, 0);
    const frameSrc2 = canvasGif.toDataURL('image/png');
    // const frameSrc2 = framesUrls[i];
    const frame2 = new Image();
    frame2.src = frameSrc2;
    frameImages[i] = frame2;
  }
  return frameImages;
}

exportGif.onclick = () => {
  gifshot.createGIF({
    images: prepareForGif(),
    interval: 1 / speedRange.value,
    // gifWidth: canvasCurrVirtualSize, // break colors - gifshot full of bugs
    // gifHeight: canvasCurrVirtualSize, // break colors - gifshot full of bugs
  }, (obj) => {
    if (!obj.error) {
      const imageTemp = obj.image;

      const linkToSave = document.createElement('a');
      linkToSave.setAttribute('download', 'piskelGIF.gif');
      linkToSave.setAttribute('href', imageTemp);
      linkToSave.click();
    }
  });
};

function encodeApng() {
  const canvasApng = document.createElement('canvas');
  canvasApng.width = canvasCurrVirtualSize;
  canvasApng.height = canvasCurrVirtualSize;
  const encoder = new APNGencoder(canvasApng);
  encoder.start();
  encoder.setRepeat(0);
  encoder.setDelay(100 / speedRange.value);
  encoder.setDispose(1);
  encoder.setBlend(1);
  for (let i = 0; i < framesHTML.children.length - 1; i++) {
    const myImageData = canvasCur(i).getContext('2d').getImageData(0, 0, canvasCurrVirtualSize, canvasCurrVirtualSize);
    canvasApng.getContext('2d').putImageData(myImageData, 0, 0);
    encoder.addFrame(canvasApng.getContext('2d'));
  }
  encoder.finish();

  const out = encoder.stream();
  return new Blob([new Uint8Array(out.bin)], { type: 'image/apng' });
}

exportApng.onclick = () => {
  const linkToSave = document.createElement('a');
  linkToSave.href = URL.createObjectURL(encodeApng());
  linkToSave.download = 'piskelAPNG.apng';
  linkToSave.click();
};

// ==================      AUTHORIZATION      ================== //

const logIn = document.getElementById('logIn');
const logOut = document.getElementById('logOut');
const userInfo = document.getElementById('userInfo');
const userImg = document.getElementById('userImg');
const userName = document.getElementById('userName');

const CLIENT_ID = '289122285352-3cb7qhvktpmmibb2l9rn8vkdfolsrsb6.apps.googleusercontent.com';
const API_KEY = 'AIzaSyAgNTjc1d148xrWYqHNHY-z0fsv_dGP27c';
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
const SCOPES = 'https://www.googleapis.com/auth/drive';

function init() {
  window.gapi.load('auth2', () => {
    window.gapi.auth2.init({
      apiKey: API_KEY,
      clientId: CLIENT_ID,
      discoveryDocs: DISCOVERY_DOCS,
      scope: SCOPES,
    }).then(() => console.log('init OK'), () => console.log('init ERR'));
  });
  window.gapi.load('client:auth2', initClient);
}

function initClient() {
  window.gapi.client.init({
    apiKey: API_KEY,
    clientId: CLIENT_ID,
    discoveryDocs: DISCOVERY_DOCS,
    scope: SCOPES,
  }).then(() => {
    console.log('init OK');
  }, () => console.log('init ERR'));
}

function listFiles() {
  window.gapi.client.drive.files.list({
    pageSize: 10,
    fields: 'nextPageToken, files(id, name)',
  }).then((response) => {
    console.log('Files:');
    const { files } = response.result;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        console.log(`${file.name} (${file.id})`);
      }
    } else {
      console.log('No files found');
    }
  });
}

window.onload = function () {
  init();
};

logIn.onclick = () => {
  // eslint-disable-next-line arrow-parens
  const authOk = googleUser => {
    logIn.style.display = 'none';
    userInfo.style.display = 'flex';
    logOut.style.display = 'block';
    apngToGDriveWait.style.display = 'none';
    apngToGDrive.style.display = 'block';

    userImg.src = googleUser.getBasicProfile().getImageUrl();
    userName.innerHTML = googleUser.getBasicProfile().getName().toString();

    listFiles();
  };
  const authErr = () => {
    console.log('Auth ERR');
  };
  const GoogleAuth = window.gapi.auth2.getAuthInstance();
  GoogleAuth.signIn({
    scope: 'profile email',
  }).then(authOk, authErr);
};

logOut.onclick = () => {
  // eslint-disable-next-line arrow-parens
  const signOutOk = () => {
    logIn.style.display = 'block';
    userInfo.style.display = 'none';
    logOut.style.display = 'none';

    apngToGDriveWait.style.display = 'block';
    apngToGDrive.style.display = 'none';
  };
  const signOutErr = () => {
    console.log('signOut ERR');
  };
  const GoogleAuth = window.gapi.auth2.getAuthInstance();
  GoogleAuth.signOut().then(signOutOk, signOutErr);
};

// ==================      EXPORT TO GOOGLE DRIVE      ================== //

function uploadToGDrive(file, metadata) {
  const accessToken = window.gapi.auth.getToken().access_token;
  console.log('accessToken: ', accessToken);
  const form = new FormData();
  form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
  form.append('file', file);

  fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id', {
    method: 'POST',
    headers: new Headers({ Authorization: `Bearer ${accessToken}` }),
    body: form,
  }).then(res => res.json()).then((val) => {
    console.log(val);
  });
}

apngToGDrive.onclick = () => {
  const file = encodeApng();
  const metadata = {
    name: 'piskelAPNG.apng',
    mimeType: 'image/apng',
  };
  uploadToGDrive(file, metadata);
};

// ==================      TOOL ACTIVATION FUNCTIONALITY      ================== //

const ctxMain = canvasMain.getContext('2d');
const ctxToCursor = canvasToCursor.getContext('2d');


const toolState = {
  currentToolId: '',
  primaryColor: '#ffff00',
  secondaryColor: '#c231d2',
};

function changeTool(e, clickedElement) {
  canvasToCursor.classList.remove(`${toolState.currentToolId}Cursor`);
  toolRectangle.classList.remove('highlight');
  toolPen.classList.remove('highlight');
  toolStroke.classList.remove('highlight');
  toolEraser.classList.remove('highlight');
  toolPaintcanvas.classList.remove('highlight');
  toolColorswap.classList.remove('highlight');
  toolLighter.classList.remove('highlight');
  toolRainbow.classList.remove('highlight');
  toolColorpicker.classList.remove('highlight');
  if (toolState.currentToolId === clickedElement.id) toolState.currentToolId = '';
  else {
    toolState.currentToolId = clickedElement.id;
    clickedElement.classList.add('highlight');
    canvasToCursor.classList.add(`${clickedElement.id}Cursor`);
  }
  if (toolState.currentToolId === 'pen') penAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'eraser') eraserAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'stroke') strokeAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'rectangle') rectangleAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'colorswap') colorswapAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'lighter') lighterAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'paintcanvas') paintcanvasAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'rainbow') rainbowAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame);
  if (toolState.currentToolId === 'colorpicker') colorpickerAction(initColors, showCursorCoords, isMouseDown, toolState, ctxMain, canvasToCursor, ctxToCursor);
}

function tranformAction(e, clickedElement) {
  if (clickedElement.id === 'fliphorizontal') flipAction('horizontal', ctxMain, canvasMain, copyCanvas, canvasCur, returnCurrentFrame);
  if (clickedElement.id === 'flipvertical') flipAction('vertical', ctxMain, canvasMain, copyCanvas, canvasCur, returnCurrentFrame);
  if (clickedElement.id === 'rotateleft') rotateAction('left', ctxMain, canvasMain, copyCanvas, canvasCur, returnCurrentFrame);
  if (clickedElement.id === 'rotateright') rotateAction('right', ctxMain, canvasMain, copyCanvas, canvasCur, returnCurrentFrame);
}

// сhange tool by keyboard
onkeypress = (e) => {
  if (e.code === 'KeyP') changeTool(e, toolPaint);
  else if (e.code === 'KeyC') changeTool(e, toolColorpicker);
};

// сhange tool by mouse-click
tools.onclick = (e) => {
  if (e.target.tagName !== 'IMG') return;
  const target = e.target.closest('.btn');
  changeTool(e, target);
};

tranform.onclick = (e) => {
  if (e.target.tagName !== 'IMG') return;
  const target = e.target.closest('.btn');
  tranformAction(e, target);
};

// ==================      SCALE FUNCTIONALITY      ================== //

let currentFrame = 0;

const canvasMainRealSize = 512;
const canvasPreviewRealSize = 200;
const canvasFrameRealSize = 128;
let canvasCurrVirtualSize = 32;
let canvasPrevVirtualSize = 32;

function scaleOne(someCanvas, realSize, marginCorrection) {
  someCanvas.width = canvasCurrVirtualSize;
  someCanvas.height = canvasCurrVirtualSize;
  someCanvas.style.transform = `scale(${realSize / someCanvas.width}, ${realSize / someCanvas.height})`;
  someCanvas.style.marginTop = `${(realSize - someCanvas.height) / 2 - marginCorrection}px`;
  someCanvas.style.marginLeft = `${(realSize - someCanvas.width) / 2 - marginCorrection}px`;
}

function scaleCanvas() {
  canvasPrevVirtualSize = canvasCurrVirtualSize;
  canvasCurrVirtualSize = canvasSize.value;
  const pointToInsert = (canvasCurrVirtualSize - canvasPrevVirtualSize) / 2;
  const marginCorr0 = 0;
  const marginCorr1 = 1;

  scaleOne(canvasMain, canvasMainRealSize, marginCorr1);
  scaleOne(canvasToCursor, canvasMainRealSize, marginCorr1);
  scaleOne(canvasPreview, canvasPreviewRealSize, marginCorr0);
  for (let i = 0; i < framesHTML.children.length - 1; i++) {
    const myImageData = canvasCur(i).getContext('2d').getImageData(0, 0, canvasPrevVirtualSize, canvasPrevVirtualSize);
    scaleOne(canvasCur(i), canvasFrameRealSize, marginCorr0);
    canvasCur(i).getContext('2d').putImageData(myImageData, pointToInsert, pointToInsert);
    framesUrls[i] = canvasCur(i).toDataURL('image/png');
  }
  copyCanvas(canvasCur(returnCurrentFrame()), canvasMain);

  showCursorCoords();
}

function showCursorCoords(x, y) {
  if (x && y) cursorCoords.innerHTML = `[${canvasSize.value}x${canvasSize.value}]: ${x}x${y}`;
  else cursorCoords.innerHTML = `[${canvasSize.value}x${canvasSize.value}]`;
}

scaleCanvas();

canvasSize.onchange = () => {
  scaleCanvas();
};

// ==================      FRAMES FUNCTIONALITY      ================== //

function returnCurrentFrame() {
  return currentFrame;
}

function findCurFrame(e) {
  let curFramebox;
  if (e.classList) {
    if (e.classList.value === 'frameBox' || e.classList.value === 'frameBox current') curFramebox = e;
  } else curFramebox = e.target.closest('.frameBox');
  const allFrameBoxes = [];
  for (let i = 0; i < framesHTML.children.length - 1; i++) {
    allFrameBoxes.push(framesHTML.children[i]);
  }
  return allFrameBoxes.indexOf(curFramebox);
}

function findLastFrame() {
  return framesHTML.children.length - 2;
}

function activateCurFrame(i) {
  for (let j = 0; j < framesHTML.children.length - 1; j++) {
    framesHTML.children[j].classList.remove('current');
    framesHTML.children[j].children[2].innerHTML = j + 1;
  }
  framesHTML.children[i].classList.add('current');
  copyCanvas(canvasCur(i), canvasMain);
  if (framesHTML.children.length - 1 === 1) framesHTML.children[0].children[1].classList.add('hide');
  else framesHTML.children[0].children[1].classList.remove('hide');
}

// find index of clicked frame
framesHTML.onclick = (e) => {
  if (e.target.classList.value === 'frame') {
    currentFrame = findCurFrame(e);
    activateCurFrame(currentFrame);
  }
};

function canvasCur(i) {
  return framesHTML.children[i].lastElementChild;
}

function clearCanva() {
  ctxMain.beginPath();
  ctxMain.clearRect(0, 0, canvasMain.width, canvasMain.height);
  ctxMain.fill();
}

function zeroFrame() {
  clearCanva();
  const ctxCur = canvasCur(0).getContext('2d');
  activateCurFrame(currentFrame);
  ctxCur.beginPath();
  ctxCur.clearRect(0, 0, canvasCur(0).width, canvasCur(0).height);
  framesUrls[currentFrame] = canvasCur(0).toDataURL('image/png');
}

zeroFrame();

function addNewFrame() {
  const markup = `
    <div class="frameBox">
        <button class="copy"><img class="copyImg" src="src/icons/frame-copy.png" alt="frame-copy.png"></button>
        <button class="del"><img class="delImg" src="src/icons/frame-del.png" alt="frame-del.png"></button>
        <div class="frameNumber"></div>
        <canvas class="frame" width="32" height="32"></canvas>
    </div>
  `;
  newFrameBtn.insertAdjacentHTML('beforebegin', markup);
  currentFrame = findLastFrame();
  scaleOne(canvasCur(currentFrame), canvasFrameRealSize, 0);
  framesUrls[currentFrame] = canvasCur(currentFrame).toDataURL('image/png');
  activateCurFrame(currentFrame);
}

function findFrameBox(e) {
  let { target } = e;
  const findParent = () => {
    target = target.parentNode;
    if (!target.classList.contains('frameBox')) {
      findParent();
    }
    return target;
  };
  return findParent();
}

function copyFrame(e) {
  const markup = `
    <div class="frameBox">
      <button class="copy"><img class="copyImg" src="src/icons/frame-copy.png" alt="frame-copy.png"></button>
      <button class="del"><img class="delImg" src="src/icons/frame-del.png" alt="frame-del.png"></button>
      <div class="frameNumber"></div>
      <canvas class="frame" width="32" height="32"></canvas>
    </div>
  `;
  currentFrame = findCurFrame(findFrameBox(e));
  framesHTML.children[currentFrame].insertAdjacentHTML('afterend', markup);
  const canvasCopyFrom = canvasCur(currentFrame);
  framesUrls.splice(currentFrame, 0, canvasCur(currentFrame).toDataURL('image/png'));
  currentFrame++;
  scaleOne(canvasCur(currentFrame), canvasFrameRealSize, 0);
  const canvasCopyTo = canvasCur(currentFrame);
  copyCanvas(canvasCopyFrom, canvasCopyTo);
  activateCurFrame(currentFrame);
}

function deleteFrame(e) {
  const index = findCurFrame(findFrameBox(e));
  document.getElementById('frames').removeChild(findFrameBox(e));
  framesUrls.splice(index, 1);
  if (returnCurrentFrame() >= index && returnCurrentFrame() !== 0) currentFrame--;
  activateCurFrame(currentFrame);
}

addFrameBtn.addEventListener('click', () => {
  addNewFrame();
  clearCanva();
});

document.addEventListener('click', (e) => {
  if (e.target.classList.value === 'copyImg' || e.target.classList.value === 'copy') copyFrame(e);
  if (e.target.classList.value === 'delImg' || e.target.classList.value === 'del') deleteFrame(e);
});

document.addEventListener('contextmenu', (e) => {
  e.preventDefault();
});

// ==================      ANIMATION      ================== //

function draw(frameSrc) {
  const frame = new Image();
  frame.src = frameSrc;
  ctxPreview.clearRect(0, 0, canvasPreview.width, canvasPreview.height);
  ctxPreview.drawImage(frame, 0, 0);
}

let count = 0;
let intervalX;

function startAnimation() {
  if (intervalX) clearInterval(intervalX);
  intervalX = setInterval(() => {
    const frameSrc = framesUrls[count % framesUrls.length];
    draw(frameSrc);
    count++;
  }, 1000 / speedRange.value);
}

function toggleFullScreen() {
  if (!document.fullscreenElement) {
    canvasPreview.requestFullscreen();
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
  }
}

startAnimation();

speedRange.onmousemove = () => {
  speedRangeValue.innerHTML = `${speedRange.value.toString()} FPS`;
};

speedRange.onmouseup = () => {
  startAnimation();
};

fullscreen.onclick = () => {
  toggleFullScreen();
};

// ==================      TOOLS USAGE FUNCTIONALITY      ================== //

let isMouseDown = false;

function initColors(primaryCol, secondaryCol) {
  primaryColor.value = primaryCol;
  secondaryColor.value = secondaryCol;
}

initColors(toolState.primaryColor, toolState.secondaryColor);

swapColors.onclick = () => {
  const tempColor = toolState.primaryColor;
  toolState.primaryColor = toolState.secondaryColor;
  toolState.secondaryColor = tempColor;
  initColors(toolState.primaryColor, toolState.secondaryColor);
};

primaryColor.onchange = () => {
  toolState.primaryColor = primaryColor.value;
};

secondaryColor.onchange = () => {
  toolState.secondaryColor = secondaryColor.value;
};

function copyCanvas(fromCanvas, toCanvas) {
  const myImageData = fromCanvas.getContext('2d').getImageData(0, 0, canvasCurrVirtualSize, canvasCurrVirtualSize);
  toCanvas.getContext('2d').putImageData(myImageData, 0, 0);
  framesUrls[returnCurrentFrame()] = canvasCur(returnCurrentFrame()).toDataURL('image/png');
}
